import { FormControl } from '@angular/forms';
import { DirectDebitFormField } from '../../models/direct-debit/direct-debit-form-field.enum';
import { DirectDebitForm } from '../../models/direct-debit/direct-debit-form.interface';

export const mockDirectDebitForm: DirectDebitForm = {
  [DirectDebitFormField.AccountName]: new FormControl(null),
  [DirectDebitFormField.AccountNumber]: new FormControl(null),
  [DirectDebitFormField.IBAN]: new FormControl(null),
  [DirectDebitFormField.SortCode]: new FormControl(null),
  [DirectDebitFormField.PaymentDate]: new FormControl(null),
  [DirectDebitFormField.AccountHolderConfirmation]: new FormControl(null),
  [DirectDebitFormField.TermsAndConditions]: new FormControl(null),
  [DirectDebitFormField.PaperlessPreference]: new FormControl(null),
  [DirectDebitFormField.PaymentToken]: new FormControl(null),
};
